import * as React from "react";
const SvgPlus32 = (props, ref) => React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "currentColor", viewBox: "0 0 32 32", ref: ref, ...props },
    React.createElement("path", { fill: "currentColor", d: "M15 28a1 1 0 1 0 2 0V17h11a1 1 0 1 0 0-2H17V4a1 1 0 1 0-2 0v11H4a1 1 0 1 0 0 2h11v11Z" }));
const ForwardRef = React.forwardRef(SvgPlus32);
export default ForwardRef;
